<template>
	<div class="default-layout">
		<MainMenu/>
		<transition name="header" mode="out-in" appear>
			<header id="home-header" class="header" :key="$route.path" v-if="$route.name==='home'">
				<div class="container">
					<div class="content">
						<div class="top">
								<router-link :to="{name: 'home'}" id="logo" :key="$route.path">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60"><path class="A" d="M104.18 30a30 30 0 0 0 30 30h126.5a8 8 0 0 0 6.39-3.58l32.36-52.84s2.2-3.58-2-3.58H134.18a30 30 0 0 0-30 30"/><path class="B" d="M158.5 27.7h-22.37l-4.6 4.6h10.87a8.88 8.88 0 1 1-2.3-8.58l3.25-3.25a13.49 13.49 0 1 0 3.75 11.84h6.66a20.08 20.08 0 1 1-5.76-16.5l3.25-3.25A24.671 24.671 0 1 0 158.49 30zm71.15 16.52c0 3-1.25 4.77-3.9 4.77h-3.82V32.77h3.82c2.64 0 3.9 1.9 3.9 4.92zM229 22.56c0 3-1.32 4.92-4 4.92h-3.16V17c0-3.38 1.25-4.92 3.6-4.92S229 13.6 229 17zm7 21.8v-7c0-3.67-1.62-6.54-4.26-7.64a7.77 7.77 0 0 0 3.67-6.9v-6.22c0-6.54-3.52-10.28-9.84-10.28s-9.9 3.75-9.9 10.28v38.2h10.13c7.2 0 10.2-4.1 10.2-10.43m-34.64-13.5H194V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.32 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2H194V36.6h7.34v18.2zm-25.2 0v-5.88H177c-2.64 0-3.9-1.84-3.9-4.85V6.92h-6.32v37.45c0 6.32 2.8 10.43 10.06 10.43z"/><path class="C" d="M95.84 54.8V16.6c0-6.54-3.9-10.28-10-10.28s-10 3.75-10 10.28v38.2h6.32V17c0-3.16 1.47-4.92 3.67-4.92s3.67 1.7 3.67 4.92v37.8zM64.26 23.5c0 3-1.25 4.92-3.9 4.92h-3.45V17c0-3.38 1.4-4.92 3.75-4.92s3.6 1.54 3.6 4.92zm6.3 31.3V38.64c0-3.67-1.32-6.83-4-7.93a8 8 0 0 0 4-7.2v-7c0-6.54-3.6-10.28-9.9-10.28S50.6 10.07 50.6 16.6v38.2h6.32V33.72h3.45c2.64 0 3.9 1.9 3.9 4.92V54.8zm-32-23.94H31.2V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.3 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2h6.32V36.6h7.34v18.2zm-24.6-28.27V6.92H14v19.24c0 3.38-1.47 4.92-3.82 4.92s-3.82-1.54-3.82-4.92V6.92H0v19.6c0 5.36 2.57 8.9 7.05 9.9V54.8h6.32V36.44c4.33-1 7-4.55 7-9.9"/></svg>
								</router-link>
							<span @click="$store.dispatch('openMenu')" id="menu" class="link-icon" tabindex="0">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="A" d="M0 0h24v24H0z"/><path class="B" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
							</span>
						</div>
						<p class="sub-title">
							{{$t('app-subtitle1')}}<br>
							{{$t('app-subtitle2')}}<br>
							{{$t('app-subtitle3')}}
						</p>
						<p class="credits">{{$t('produced-by')}}&nbsp;<router-link :to="{name: 'about-us'}" class="credits-link">{{$t('gualchieri-e-gualchieri')}}</router-link></p>
					</div>
				</div>
			</header>
			<header class="header" :key="$route.path" v-else>
				<div class="container">
					<div class="content">
						<div class="top">
								<router-link :to="{name: 'home'}" id="logo" :key="$route.path">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60"><path class="A" d="M104.18 30a30 30 0 0 0 30 30h126.5a8 8 0 0 0 6.39-3.58l32.36-52.84s2.2-3.58-2-3.58H134.18a30 30 0 0 0-30 30"/><path class="B" d="M158.5 27.7h-22.37l-4.6 4.6h10.87a8.88 8.88 0 1 1-2.3-8.58l3.25-3.25a13.49 13.49 0 1 0 3.75 11.84h6.66a20.08 20.08 0 1 1-5.76-16.5l3.25-3.25A24.671 24.671 0 1 0 158.49 30zm71.15 16.52c0 3-1.25 4.77-3.9 4.77h-3.82V32.77h3.82c2.64 0 3.9 1.9 3.9 4.92zM229 22.56c0 3-1.32 4.92-4 4.92h-3.16V17c0-3.38 1.25-4.92 3.6-4.92S229 13.6 229 17zm7 21.8v-7c0-3.67-1.62-6.54-4.26-7.64a7.77 7.77 0 0 0 3.67-6.9v-6.22c0-6.54-3.52-10.28-9.84-10.28s-9.9 3.75-9.9 10.28v38.2h10.13c7.2 0 10.2-4.1 10.2-10.43m-34.64-13.5H194V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.32 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2H194V36.6h7.34v18.2zm-25.2 0v-5.88H177c-2.64 0-3.9-1.84-3.9-4.85V6.92h-6.32v37.45c0 6.32 2.8 10.43 10.06 10.43z"/><path class="C" d="M95.84 54.8V16.6c0-6.54-3.9-10.28-10-10.28s-10 3.75-10 10.28v38.2h6.32V17c0-3.16 1.47-4.92 3.67-4.92s3.67 1.7 3.67 4.92v37.8zM64.26 23.5c0 3-1.25 4.92-3.9 4.92h-3.45V17c0-3.38 1.4-4.92 3.75-4.92s3.6 1.54 3.6 4.92zm6.3 31.3V38.64c0-3.67-1.32-6.83-4-7.93a8 8 0 0 0 4-7.2v-7c0-6.54-3.6-10.28-9.9-10.28S50.6 10.07 50.6 16.6v38.2h6.32V33.72h3.45c2.64 0 3.9 1.9 3.9 4.92V54.8zm-32-23.94H31.2V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.3 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2h6.32V36.6h7.34v18.2zm-24.6-28.27V6.92H14v19.24c0 3.38-1.47 4.92-3.82 4.92s-3.82-1.54-3.82-4.92V6.92H0v19.6c0 5.36 2.57 8.9 7.05 9.9V54.8h6.32V36.44c4.33-1 7-4.55 7-9.9"/></svg>
								</router-link>
							<span @click="$store.dispatch('openMenu')" id="menu" class="link-icon" tabindex="0">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="A" d="M0 0h24v24H0z"/><path class="B" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
							</span>
						</div>
					</div>
				</div>
			</header>
		</transition>
		<transition name="fade" mode="out-in" appear>
			<slot/>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import MainMenu from '@/components/MainMenu.vue'

export default {
	components: {
		MainMenu
	},
}
</script>

<style>
.default-layout {
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: var(--body_background_color);
	height: 100%;
	min-height: 60.0rem;
	overflow: auto;
}

.default-layout .header {
	padding: 1.6rem 0;
	background-color: #fff;
	color: var(--primary_text_color);
	flex-shrink: 0;
	transition: all .4s;
	max-height: 72.0rem;
}

.default-layout .header:not(#home-header) {
	position: sticky;
	top: 0;
	z-index: 100;
	box-shadow: 0 0 .2rem rgba(0,0,0,0.5);	
}

.default-layout .header .top {
	display: flex;
	justify-content: space-between;
}

.default-layout .header path {
	fill: var(--primary_text_color);
	transition: all .4s;
}

.default-layout .header #logo {
	display: flex;
	padding: .4rem 0;
}

.default-layout .header #logo svg {
	width: auto;
	height: 4.8rem;
	max-height: 3.2rem;
	transition: all .4s;
}

.default-layout .header #logo .A {
	fill: var(--primary_color);
}

.default-layout .header #logo .B {
	fill: var(--inverse_text_color);
}

.default-layout .header #menu svg {
	width: 100%;
	height: 100%;
}

.default-layout .header #menu .A {
	fill: none;
}

.default-layout #home-header {
	background: #222 url(../assets/home.png) no-repeat center center;
	background-size: cover;
	color: var(--inverse_text_color);
	max-height: 500px;
	flex-grow: 1;
}

.default-layout #home-header path {
	fill: var(--inverse_text_color);
}

.default-layout .header,
.default-layout .header .container,
.default-layout .header .container .content {
	display: flex;
	flex-direction: column;
}

.default-layout .header .container,
.default-layout .header .container .content {
	flex-grow: 1;
}


.default-layout #home-header #logo {
	color: var(--inverse_text_color);
}

.default-layout #home-header #logo svg {
	max-height: 4.8rem;
}

.default-layout #home-header #logo .A {
	fill: var(--primary_color);
}

.default-layout #home-header #logo .B {
	fill: var(--inverse_text_color);
}

.default-layout #home-header #logo .C {
	fill: var(--inverse_text_color);
}


.default-layout #home-header .sub-title {
	font-family: 'Charlet Comprime';
	font-size: 3.6rem;
	line-height: 3.6rem;
	font-weight: 500;
	padding: 3.2rem 0;
	display: flex;
	flex-grow: 1;
	margin-bottom: 0;
	align-items: center;
	display: flex;
	transition: opacity .4s;
}

.default-layout .header .link-icon {
	width: 4.0rem;
	height: 4.0rem;
}

.default-layout #home-header .credits {
	position: absolute;
	bottom: 0;
	right: 2.0rem;
	margin-bottom: 0;
	font-size: 1.8rem;
}

.default-layout #home-header .credits .credits-link {
	background: var(--primary_color);
	color: var(--inverse_text_color);
	border-radius: .3rem;
	padding: 0 .3rem;
}

.default-layout .main {
	padding: 1.6rem 0;
}

.default-layout #navigation {
	padding: 1.6rem 0;
	background-color: var(--primary_color);
	color: var(--inverse_text_color);
	font-size: 2.4rem;
	line-height: 4.0rem;
}

.default-layout #navigation a {
	color: var(--inverse_text_color);
}

.default-layout #navigation .dot-menu .dot-menu-handler {
	width: 4.0rem !important;
	height: 4.0rem !important;
}

.default-layout #navigation .dot-menu .dot-menu-handler-icon path {
	fill: var(--inverse_text_color);
}

.default-layout #navigation .container {
	/*overflow: hidden;*/ /* Non mi ricordo perchè lo avevo messo ma con questo non vedo il menu*/
}

.default-layout #navigation .flex {
	display: flex;
	align-items: center;
}

.default-layout #navigation .go-back {
	margin-right: .8rem;
	cursor: pointer;
}

.default-layout .navigation-icon {
	display: block;
	width: 4.0rem;
	height: 4.0rem;
}

.default-layout .navigation-icon.left {
	margin-right: .8rem;
}

.default-layout .navigation-icon.small {
	padding: .8rem;
}

.default-layout .navigation-icon path {
	fill: var(--inverse_text_color);
}

.default-layout .navigation-right {
	margin-left: auto;
}

.default-layout .page {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	position: relative;
}

/*Customer area*/
.default-layout .customer-area-enter-active,
.default-layout .customer-area-leave-active {
	transition: transform .4s, opacity .4s;
}

.default-layout .customer-area-enter,
.default-layout .customer-area-leave-to {
	transform: translateY(8.0rem);
	opacity: 0;
}

/*Header*/
.default-layout .header-enter,
.default-layout .header-leave-to {
	max-height: 7.2rem !important;
	background: #fff !important;
}

.default-layout .header-enter #logo svg,
.default-layout .header-leave-to #logo svg {
	max-height: 3.2rem !important;
}

.default-layout .header-enter path,
.default-layout .header-leave-to path {
	fill: var(--primary_text_color) !important;
}
.default-layout .header-enter #logo .A,
.default-layout .header-leave-to #logo .A {
	fill: var(--primary_color) !important;
}

.default-layout .header-enter #logo .B,
.default-layout .header-leave-to #logo .B {
	fill: var(--inverse_text_color) !important;
}

.default-layout .header-enter #menu .A,
.default-layout .header-leave-to #menu .A {
	fill: none !important;
}

.default-layout .header-enter .sub-title,
.default-layout .header-leave-to .sub-title {
	opacity: 0;
}

.default-layout .header .credits {
	transition: opacity .4s ease .3s;
}

.default-layout .header-leave-active .credits {
	transition: none;
}

.default-layout .header-enter .credits,
.default-layout .header-leave-to .credits {
	opacity: 0;
}
</style>